import { render, staticRenderFns } from "./Win.vue?vue&type=template&id=a1361416&scoped=true&"
import script from "./Win.vue?vue&type=script&lang=js&"
export * from "./Win.vue?vue&type=script&lang=js&"
import style0 from "./Win.vue?vue&type=style&index=0&id=a1361416&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1361416",
  null
  
)

export default component.exports